module.exports = __webpack_public_path__ + "static/KC2-adb3a449639185d62713f443bc960884.png";